import Button from '@doordash/component-button'
import { IdentificationField } from '@doordash/component-fields'
import { CountryCode } from '@doordash/lib-i18n'
import * as React from 'react'
import { connect } from 'react-redux'

import { Text, StackChildren } from '@doordash/design-language'

import { COUNTRY_SHORTCODES } from '../../../../constants'
import { validators } from './validators'

import * as actions from '../../../../actions'
import * as events from '../../../../events'
import * as DA from '../../../../typeModules/events'
import t from './strings'

const retrieveStringsByCountry = country => {
  switch (country) {
    case COUNTRY_SHORTCODES.US:
      return {
        title: t.usaTitle(),
        label: t.usaLabel(),
      }
    case COUNTRY_SHORTCODES.CA:
      return {
        title: t.caTitle(),
        label: t.caLabel(),
      }
    case COUNTRY_SHORTCODES.AU:
      return {
        title: t.ausTitle(),
        label: t.ausLabel(),
      }
    default:
      return {
        title: t.usaTitle(),
        label: t.usaLabel(),
      }
  }
}

type Props = {
  goToNextStep: () => void
  onSubmit?: () => Promise<any>
  returnLink?: () => void
  updatePaymentAccount?: (paymentAccountId, data) => Promise<any>
  paymentAccountId?: string
  trackBankAdditionalVerification?: (
    data: DA.BankAdditionalVerification
  ) => Promise<any>
  country?: CountryCode
}

type State = {
  identificationValue: string
  fieldError: string
  isLoading: boolean
}

export class IdentificationNumber extends React.Component<Props, State> {
  public state = {
    identificationValue: '',
    fieldError: null,
    isLoading: false,
  }

  public componentDidMount() {
    const { trackBankAdditionalVerification, country } = this.props

    trackBankAdditionalVerification({
      country: COUNTRY_SHORTCODES[country],
      action: DA.EventActions.Rendered,
      name: DA.BankAdditionalVerificationPages.IdentificationNumber,
    })
  }

  public handleChange = identificationValue => {
    this.setState({ identificationValue })
  }

  public handleSubmit = async () => {
    const {
      goToNextStep,
      updatePaymentAccount,
      paymentAccountId,
      country,
      trackBankAdditionalVerification,
    } = this.props
    const { identificationValue } = this.state

    const error = validators.identification(identificationValue)
    this.setState({ fieldError: error })

    if (error == null) {
      this.setState({ isLoading: true })

      const payload = {
        personal_identification_number: identificationValue,
        ssn_last_4: identificationValue.slice(-4),
      }

      try {
        await updatePaymentAccount(paymentAccountId, payload)

        trackBankAdditionalVerification({
          country: COUNTRY_SHORTCODES[country],
          action: DA.EventActions.Submit,
          name: DA.BankAdditionalVerificationPages.IdentificationNumber,
        })
      } catch (e) {
        this.setState({ isLoading: false })

        trackBankAdditionalVerification({
          country: COUNTRY_SHORTCODES[country],
          action: DA.EventActions.Error,
          name: DA.BankAdditionalVerificationPages.IdentificationNumber,
        })

        return
      }

      goToNextStep()
    }
  }

  public render() {
    const { country } = this.props
    const { isLoading } = this.state
    const localizedT = retrieveStringsByCountry(country)

    return (
      <React.Fragment>
        <StackChildren>
          <Text
            styles={Text.Styles.PageTitle}
            textAlign={Text.TextAlignments.Center}
          >
            {localizedT.title}
          </Text>
          <IdentificationField
            label={localizedT.label}
            country={country}
            onChange={this.handleChange}
            onBlur={() => this.setState({ fieldError: null })}
            error={this.state.fieldError}
            value={this.state.identificationValue}
          />
          <Button
            onClick={this.handleSubmit}
            type={Button.Types.Primary}
            state={isLoading ? Button.States.Loading : Button.States.Default}
          >
            {t.primaryAction()}
          </Button>
        </StackChildren>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  country: state.application.country,
  paymentAccountId: state.paymentAccount.id,
})

const mapDispatchToProps = {
  updatePaymentAccount: actions.updatePaymentAccount,
  trackBankAdditionalVerification: events.trackBankAdditionalVerification,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IdentificationNumber)
